import React from "react"
import FormInvestor from "./Form"
import ManageInvestor from "./ManageItem"

export default function UpdateInvestor({ params }) {

  return <ManageInvestor
    params={ params }
    callback={ data => <FormInvestor investor={ data } /> }
  />
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Update.js